import React from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isSetItemEnabled from 'shared/utils/localStorageHelpers';
import { getStoreLocation, setStores } from 'shared/utils/storeLocationHelpers';
import { actions as notificationActions, SnackbarSettings } from 'redux/domain/Notification';
import Global from '../components/Global';
import StoreLocationContainer from '../../StoreLocation';

/**
 * A global container that will always be rendered. This should be used as a holding place for
 * components that can be displayed from anywhere in the app such as notifications.
 * This component is hooked up to the Redux store so to use register this component with Redux
 * to listen for your state changes.
 * @param {React} props
 */
class GlobalContainer extends React.Component {
	UNSAFE_componentWillMount() {
		isSetItemEnabled();
		if (getStoreLocation() === 0) {
			setStores();
		}
	}

	render() {
		const { notification } = this.props;
		return (
			<div>
				<Global notification={notification} />
				<StoreLocationContainer />
			</div>
		);
	}
}

GlobalContainer.propTypes = {
	notification: PropTypes.instanceOf(SnackbarSettings).isRequired,
};
// make state available via props
const mapStateToProps = state => {
	const notification = state.notification.get('notification');
	return {
		notification,
	};
};

// make actions from two domains available via props
const mapDispatchToProps = dispatch => bindActionCreators({ ...notificationActions }, dispatch);

// for testing purposes
export { GlobalContainer as GlobalContainerClass };
export default connect(mapStateToProps, mapDispatchToProps)(GlobalContainer);
